import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '../../../../util/request.js';
import appConfig from '../../../../config';

export default class CheckRecordApi{

    static QUERY_CHECK_ORDER_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/list";
    static QUERY_CHECK_ORDER_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/detail";
    static APPROVE_CHECK_ORDER = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/approve";
    static DISMISSAL_CHECK_ORDER = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/dismissal";
    static CHANGE_WRITE_OFF_PLAN_TIME = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/changeWriteOffPlanTime";
    static WRITE_OFF_ASSESS_QUESTION = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/writeOffAssessQuestion";
    static EXPORT_CHECK_ORDER_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/export/list";
    static EXPORT_CHECK_ORDER_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/manager/checkOrder/export";

    static IMG_UPLOAD_URL = appConfig.gatewayUrl+appConfig.pdServicePath+"/common/file/upload";

    static listCheckOrder(params){
		return httpPost(CheckRecordApi.QUERY_CHECK_ORDER_LIST,params);
    }

    static detailCheckOrder(params){
		return httpGet(CheckRecordApi.QUERY_CHECK_ORDER_DETAIL,params);
    }

    static approveCheckOrder(params){
		return httpPostForm(CheckRecordApi.APPROVE_CHECK_ORDER,params);
    }

    static dismissalCheckOrder(params){
		return httpPostForm(CheckRecordApi.DISMISSAL_CHECK_ORDER,params);
    }

    static changeWriteOffPlanTime(params){
      return httpPostForm(CheckRecordApi.CHANGE_WRITE_OFF_PLAN_TIME,params);
      }

    static writeOffAssessQuestion(params){
		return httpPostForm(CheckRecordApi.WRITE_OFF_ASSESS_QUESTION,params);
    }

    static exportData(params){
    return httpDownload(CheckRecordApi.EXPORT_CHECK_ORDER_LIST,params);
    }

    static exportDetail(params){
      return httpDownload(CheckRecordApi.EXPORT_CHECK_ORDER_DETAIL,params);
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }




}